/* @source cursor @line_count 427 */
let locationOrigin = typeof window === 'undefined' ? '' : window.location.origin

if (!locationOrigin || locationOrigin.indexOf('localhost') > -1) {
  // locationOrigin = locationOrigin + '/gov'
}

const domain = locationOrigin + '/api'

const api = {
  // app
  appLoginByAccount: `${domain}/auth/login/account`,
  appIsUserLogin: `${domain}/auth/isLogin`,
  appLoginSmscode: `${domain}/auth/smscode`,
  appLoginBySms: `${domain}/auth/login/sms`,
  appLoginResetPassword: `${domain}/auth/resetpassword`,
  appGetUserInfo: `${domain}/auth/currentUserInfo`,
  appGetUserResources: `${domain}/auth/getUserResources`,
  appLogout: `${domain}/auth/logout`,
  appGetEntityByUrl: `${domain}/auth/getEntityByUrl`,
  appQueryEntityIcon: `${domain}/file/getEntityIconUrl`,
  // ***************************** common *****************************
  commonQueryOperateLog: `${domain}/log/queryList`,
  commonQueryDict: `${domain}/dict/getList`,
  // 当前用户所属区域范围
  commonQueryUserRegion: `${domain}/user/getUserRegion`,
  // 实体下所属区域范围
  commonQueryEntityRegion: `${domain}/entity/getEntityRegion`,
  commonQueryEnterpriseOpts: `${domain}/company/getCompanyByEntityId`,
  commonQueryRegions: `${domain}/adcode/queryAdCodeTree`,
  commonUploadImage: `${domain}/file/imgUpload`,
  commonUploadFile: `${domain}/file/uploadFile`,
  commonQueryRoleOpts: `${domain}/role/select/list`,
  commonQueryRoleTypeOpts: `${domain}/user/select/type/list`,
  commonQueryDecryptionResult: `${domain}/company/decry`,
  // 实体下拉框
  commonQueryUserEntities: `${domain}/entity/select/list`,
  commonQueryResourcesByEntity: `${domain}/resource/entity/tree`,
  commonQueryParkCompanyOpts: `${domain}/company/getParkCompanyInfoListByUserType`,
  // ***************************** 数据中心 *****************************
  dataCenterRegistrationAndQuota: `${domain}/dashboard/getCompanyRegistrationAndQuotaNum`,
  dataCenterViolationStatistics: `${domain}/dashboard/getViolationStatistics`,
  dataCenterViolationLineChart: `${domain}/dashboard/violation/line-chart`,
  dataCenterQueryMapInfo: `${domain}/dashboard/query/getGeoRegionInfo`,
  dataCenterRegion: `${domain}/adcode/map2D`,
  dataCenterQueryAreaRegion: `${domain}/adcode/dataCenterQueryAreaInfo`,
  dataCenterSearchBike: `${domain}/dashboard/bike/search`,
  dataCenterQueryStatisticInfo: `${domain}/dashboard/current/statistics`,
  dataCenterQueryTaskOrders: `${domain}/dashboard/taskOrder/statistics`,
  taskOrderCompanyStatistics: `${domain}/dashboard/taskOrder/company/statistics`,
  dataCenterQueryDepositionStatistics: `${domain}/dashboard/deposition/statistics`,
  dataCenterQueryCityInfo: `${domain}/dashboard/query/getBikeAggregationInfo`,
  dataCenterQueryBikeInfo: `${domain}/dashboard/query/getBikeInfo`,
  dataCenterQueryBikeDetail: `${domain}/dashboard/bike/queryBikeDetail`,
  dataCenterQueryHeatMap: `${domain}/dashboard/query-heat-map`,
  dataCenterQuerySniffHeatMap: `${domain}/bluetooth-sniff/map/queryHotMap`,
  dataCenterQuerySniffSettingConfig: `${domain}/bluetooth-sniff/map/queryConf`,
  dataCenterSaveSniffSettingConfig: `${domain}/bluetooth-sniff/map/setConf`,
  dataCenterParkingAreaInfo: `${domain}/dashboard/parking/point/list`,
  dataCenterSearchParkingArea: `${domain}/dashboard/parking/point/search`,
  dataCenterPeriodOrder: `${domain}/dashboard/period/order`,
  dataCenterBikeRemoteSearch: `${domain}/dashboard/bike/search/box`,
  dataCenterPeriodActivityBike: `${domain}/dashboard/period/activity-bike`,
  dataCenterQueryPointBikeDetail: `${domain}/dashboard/parking/point/bike-detail`,
  dataCenterEditFence: `${domain}/dashboard/parking/point/update`,
  dataCenterOpratiionLineChart: `${domain}/dashboard/maintenance/line-chart`,
  dataCenterQueryOperationInfo: `${domain}/dashboard/maintenance/point/list`,
  dataCenterQuerySearchOperationInfo: `${domain}/dashboard/maintenance/point/search`,
  dataCenterQuerySearchOperationList: `${domain}/dashboard/maintenance/point/searchList`,
  dataCenterRealTimePositionQuota: `${domain}/dashboard/getRealTimeReportAndQuotaNum`,
  dataCenterQueryLayerParamConfig: `${domain}/dashboard/layerParam/config`,
  dataCenterQueryKeyAreaOverview: `${domain}/orderly/dashboard/areaDetail/overview`,
  dataCenterQueryKeyAreaLineChart: `${domain}/orderly/dashboard/areaDetail/lineChart`,
  dataCenterQueryCameraInfo: `${domain}/dashboard/queryCameraDeviceList`,
  dataCenterQueryPatrolReminder: `${domain}/orderly/dashboard/exceptionReminder`,
  dataCenterQueryOrderlyAreaRatio: `${domain}/orderly/dashboard/areaRatio`,
  dataCenterDetailsQueryList: `${domain}/orderly/dashboard/orderlyDetail/queryList`,
  dataCenterQueryOrderlyDetailList: `${domain}/dashboard/queryOrderlyDetailList`,
  dataCenterTaskOrderStatistics: `${domain}/orderly/dashboard/taskOrder/statistics`,
  dataCenterTaskOrderFinishRatioAndCostTime: `${domain}/orderly/dashboard/taskOrder/finishRatioAndCostTime`,
  dataCenterOrderPatrolDetailsStatistics: `${domain}/orderly/dashboard/orderlyDetail/lineChart`,
  dataCenterOrderBluetoothSniffStatistics: `${domain}/bluetooth-sniff/map/queryHistogram`,
  dataCenterQueryOperationTrail: `${domain}/dashboard/maintenance/trackList`,
  // 车辆轨迹
  dataCenterQueryBikeTrack: `${domain}/dashboard/bike/track`,
  // 订单列表
  dataCenterQueryOrderList: `${domain}/orderDetails/queryList`,
  // 订单轨迹（传 orderIds）
  dataCenterQueryOrderTrack: `${domain}/dashboard/order/trackList`,
  dataCenterQueryTaskOrderList: `${domain}/taskOrder/queryTaskOrderList`,
  // 数据中心获取任务详情
  dataCenterQueryTaskOrderDetail: `${domain}/taskOrder/queryTaskOrderDetail`,
  //
  dataCenterQueryMapFences: `${domain}/dashboard/fencing/point/list`,
  // ***************************** 地铁中心 *****************************
  cyclingTrajectoryDiagram: `${domain}/mock/data/cycling-trajectory-diagram`,
  diagnosticAnalysis: `${domain}/mock/data/diagnostic-analysis`,
  dataCenterQuerySubwayBikeInfo: `${domain}/mock/data/getBikeInfo`,
  // ***************************** 巡检中心 *****************************
  patrolCenterTaskOrderStatistics: `${domain}/orderly/dashboard/taskOrder/statistics`,
  patrolCenterCostTimeStatistics: `${domain}/orderly/dashboard/taskOrder/costTime/statistics`,
  patrolCenterCostTimeQueryList: `${domain}/orderly/dashboard/taskOrder/queryList`,
  patrolCenterDetailsQueryList: `${domain}/orderly/dashboard/orderlyDetail/queryList`,
  patrolCenterActualStatistics: `${domain}/orderly/dashboard/actual/statistics`,
  patrolCenterDetailsLineChart: `${domain}/orderly/dashboard/orderlyDetail/lineChart`,
  patrolCenterFenceRemoteSearch: `${domain}/orderly/dashboard/search/box`,
  patrolCenterQueryGeoRegionInfo: `${domain}/orderly/dashboard/getGeoRegionInfo`,
  patrolCenterQueryCityInfo: `${domain}/orderly/dashboard/getAggregationInfo`,
  patrolCenterQueryKeyAreaInfo: `${domain}/orderly/dashboard/areaList`,
  patrolCenterQueryKeyAreaDetail: `${domain}/orderly/dashboard/areaDetail`,
  // ***************************** 用户管理 *****************************
  userQueryList: `${domain}/user/queryList`,
  userUpdateStatus: `${domain}/user/update/status`,
  userManageRolesUnionResources: `${domain}/resource/role/tree`,
  userManageAddUser: `${domain}/user/add`,
  userManageQueryDetail: `${domain}/user/detail`,
  userManageEditUser: `${domain}/user/update`,
  userManageAuthUser: `${domain}/user/update/accredit`,
  userManageQueryAuthDetail: `${domain}/user/accredit/detail`,
  userManageDelete: `${domain}/user/delete`,
  // ***************************** 角色管理 *****************************
  roleManageRoleList: `${domain}/role/list`,
  roleManageDeleteRole: `${domain}/role/delete`,
  roleManageInitialResources: `${domain}/role/initialResources`,
  roleManageRoleDetail: `${domain}/role/detail`,
  roleManageAdd: `${domain}/role/add`,
  roleManageEdit: `${domain}/role/edit`,
  // ***************************** 实体管理 *****************************
  entityManageEntityList: `${domain}/entity/list`,
  entityManageDeleteEntity: `${domain}/entity/delete`,
  entityManageEntityDetail: `${domain}/entity/detail`,
  entityManageInitialResources: `${domain}/entity/initialResources`,
  entityManageAddEntity: `${domain}/entity/create`,
  entityManageEdit: `${domain}/entity/update`,
  entityManageEditRegion: `${domain}/entity/update-region`,
  entityManageResourceTree: `${domain}/entity/getEntityResourceTree`,
  entityManageBusinessStrategyOptions: `${domain}/regulation-support/business-strategy/options`,
  entityManageEditResourceName: `${domain}/resource/entity/update`,
  entityManageUploadCustomAdcodeFileCode: `${domain}/customAdcode/upload`,
  entityManageCustomAdcodeFileCodeTemplate: `${domain}/customAdcode/downloadTemplate`,
  entityManageAdCodeListAndCustomAreaTree: `${domain}/entity/region`,
  // 实体UI配置
  entityUiConfigSave: `${domain}/entityUiConfig/save`,
  entityUiConfigQueryByEntityId: `${domain}/entityUiConfig/queryByEntityId`,
  entityManageEntitySortUpdate: `${domain}/resource/entity/sortUpdate`,
  // 数字哨兵配置
  digitalSentinelConfigDetail: `${domain}/entity/digitalSentinelConfig/detail`,
  digitalSentinelConfigSave: `${domain}/entity/digitalSentinelConfig/save`,
  // ***************************** 企业管理 *****************************
  // 列表查询
  companyQueryList: `${domain}/company/page`,
  // 添加车企
  companyCreate: `${domain}/company/create`,
  // 查看详情
  companyQueryDetail: `${domain}/company/detail`,
  // 品牌名称下拉框
  companyBrandNameList: `${domain}/company/getBrandNameList`,
  // 修改车企信息
  companyUpdate: `${domain}/company/update`,
  // 删除车企
  companyDelete: `${domain}/company/delete`,
  // 修改详情
  companyUpdateDetail: `${domain}/company/updateDetail`,
  // 新增修改配额
  companySaveOrUpdateQuota: `${domain}/quotaRegion/saveOrUpdateQuota`,
  // 配额回显   /quotaRegion
  companyGetQuotaDetail: `${domain}/quotaRegion/getCompanyQuota`,
  // 品牌名称
  companyBrandList: `${domain}/company/getBrandList`,
  companyBrandListByUserType: `${domain}/company/getBrandListByUserType`,
  companyGetQuotaTab: `${domain}/quotaRegion/getQuotaTab`,
  // ***************************** 管理员管理 *****************************
  // 列表查询
  administratorManageQueryList: `${domain}/user/admin/queryList`,
  // 管理员信息修改
  administratorUpdate: `${domain}/user/update`,
  // 管理员修改详情
  administratorUpdateDetail: `${domain}/user/update/detail`,
  // 管理员信息查询
  administratorDetail: `${domain}/user/detail`,
  // 管理员启用状态修改
  administratorUpdateStatus: `${domain}/user/update/status`,
  // 添加管理员
  administratorAdminAdd: `${domain}/user/admin/add`,
  // 管理员授权详情
  administratorAccreditDetail: `${domain}/user/admin/accredit/detail`,
  // 更新管理员授权
  administratorUpdateAccredit: `${domain}/user/admin/update/accredit`,
  // 按区域查询管理员可授权实体
  administratorEntityCandidates: `${domain}/entity/admin/select/list`,
  // ***************************** 车辆管理 *****************************
  // 列表
  bikeManageGetQueryList: `${domain}/registrationVehicle/getPageList`,
  // 车辆品牌列表及车企代码
  bikeManageGetAllCompanyListByEntityId: `${domain}/company/getAllCompanyListByEntityId`,
  // 模版下载
  bikeManageGetFileTemplate: `${domain}/registrationVehicle/getFileTemplate`,
  // 备案车上传文件
  bikeManageUploadFile: `${domain}/registrationVehicle/uploadFile`,
  // 备案车文件提交
  bikeManageCommitFile: `${domain}/registrationVehicle/commitFile`,
  //导出结果
  bikeManageExportQueryResult: `${domain}/registrationVehicle/exportQueryResult`,
  bikeManageRegistrationRuleSave: `${domain}/registration-validate-rule/save`,
  bikeManageQueryRegistrationRule: `${domain}/registration-validate-rule/query`,
  // 导入导出记录查询
  importExportRecord: `${domain}/importExport/record/queryList`,
  // 实时定位上报车辆管理-查询
  bikeManageGetRealTimePositionList: `${domain}/vehicleReport/getPageList`,
  // 实时定位上报车辆管理-导出
  bikeManageExportRealTimePositionResult: `${domain}/vehicleReport/exportQueryResult`,
  // 实时定位上报车辆管理-配置
  bikeManageUpdateRealTimePosition: `${domain}/entity/addEffectHoursConfig`,
  // 实时定位上报车辆管理-查询配置
  bikeManageQueryRealTimePosition: `${domain}/entity/getEffectHoursConfig`,
  bikeRegistereVerifyAddress: `${domain}/verification/queryAddress`,
  // 扣车管理
  detainCarManageQueryPage: `${domain}/impoundBike/queryPage`,
  detainCarManageExport: `${domain}/impoundBike/export`,
  detainCarManageQueryCount: `${domain}/impoundBike/queryCount`,
  // ***************************** 重码提醒配置 *****************************
  // 重码提醒配置-列表查询
  duplicateCodeReminderGetList: `${domain}/anticheatStrategy/queryPage`,
  // 重码提醒配置-新增策略
  duplicateCodeReminderAdd: `${domain}/anticheatStrategy/create`,
  // 重码提醒配置-终止策略
  duplicateCodeReminderTerminate: `${domain}/anticheatStrategy/terminate`,
  // 重码提醒配置-操作日志
  duplicateCodeReminderGetLog: `${domain}/duplicateCodeReminder/getLogList`,
  // ***************************** 重码识别记录 *****************************
  // 重码识别记录-列表查询
  duplicateCodeRecordGetList: `${domain}/repeatBikeCurrent/queryPage`,
  // 重码识别记录-详情
  duplicateCodeRecordInfo: `${domain}/repeatBikeCurrent/info`,
  // 重码识别记录-导出
  duplicateCodeRecordExport: `${domain}/repeatBikeCurrent/export`,
  // ***************************** 备案核验信息 *****************************
  bikeRegistereRecordsList: `${domain}/verification/records`,
  bikeRegistereExportQueryResult: `${domain}/verification/exportQueryResult`,
  bikeRegistereCancel: `${domain}/verification/cancel`,
  // ***************************** 违规告警 *****************************
  violationAlarmQueryList: `${domain}/violation/queryList`,
  violationAlarmExportQueryResult: `${domain}/violation/exportQueryResult`,
  violationAlarmViolationCreateOrder: `${domain}/violation/create-order`,
  violationAlarmConfig: `${domain}/violation/config`,
  violationConfigSave: `${domain}/violationConfig/saveConfig`,
  violationAlarmGetConfig: `${domain}/violation/getConfig`,
  violationConfigGetDetail: `${domain}/violationConfig/queryConfig`,
  violationAlarmGetTypeConfig: `${domain}/violation/getTypeConfig`,
  violationQueryTypeAndSourceOpts: `${domain}/violation/getTypeAndSource`,
  violationQueryCount: `${domain}/violation/exportQueryCount`,
  // ***************************** 任务工单 *****************************
  taskCenterQueryResult: `${domain}/taskOrder/queryList`,
  taskCenterResponsibleConfig: `${domain}/taskOrder/useLumpSum`,
  // taskCenterQuerySaveTypeConfig: `${domain}/taskOrder/saveTypeConfig`,
  taskCenterQuerySaveTypeConfig: `${domain}/taskOrder/save-type-config`,
  // taskCenterQueryGenerateConfig: `${domain}/taskOrder/getGenerateConfig`,
  taskCenterQueryStrategyConfigList: `${domain}/taskOrder/strategy-config-list`,

  //生单配置保存接口（新增接口）
  taskCenterSaveTaskConfig: `${domain}/taskOrder/saveConf`,
  // 生单配置查询接口
  taskCenterQueryTaskConfig: `${domain}/taskOrder/queryConf`,

  taskCenterQueryTypeConfig: `${domain}/taskOrder/getTypeConfig`,
  // taskCenterQueryByLonLat: `${domain}/adcode/queryGovAdCodeInfoByLonLat`,
  taskCenterQueryLocationByLngLat: `${domain}/adcode/queryLocationByLonLat`,
  taskCenterQuerydispatch: `${domain}/taskOrder/dispatch`,
  taskCenterGetStatusList: `${domain}/taskOrder/getStatusList`,
  taskCenterRxportQueryResult: `${domain}/taskOrder/exportQueryResult`,
  taskCenterGetFlowRecord: `${domain}/taskOrder/getFlowRecord`,
  taskCenteReview: `${domain}/taskOrder/review`,
  taskCenteInvalid: `${domain}/taskOrder/invalid`,
  taskCenteQueryAllTypeOpts: `${domain}/taskOrder/getAllTypeList`,
  taskCenteGetUserRegionDetailInfo: `${domain}/user/getUserRegionDetailInfo`,
  taskCenteGetAllEffectiveCompanyListByEntityId: `${domain}/company/getAllEffectiveCompanyListByEntityId`,
  taskCenterQueryOrderSourceConfig: `${domain}/taskOrder/orderSourceConfig`,
  taskCenterQueryStatusTrendData: `${domain}/taskOrder/orderStatusDistribution`,
  taskCenterQueryOrderCountTrend: `${domain}/taskOrder/orderCountTrend`,
  taskCenterQueryById: `${domain}/violation-alarm/deposition-history/queryById`,
  taskOrderMsgPushConfigQuery: `${domain}/taskOrder/msgPush/config/query`,
  taskOrderMsgPushConfigSave: `${domain}/taskOrder/msgPush/config/save`,
  taskOrderMsgPushConfigChooseUser: `${domain}/taskOrder/msgPush/config/chooseUser`,
  // ***************************** 围栏管理 *****************************
  fenceManageDepositionConfig: `${domain}/fencing/depositionConfig`,
  fenceManageDelete: `${domain}/fencing/delete`,
  fenceManageQueryList: `${domain}/fencing/queryList`,
  fenceManageExportQueryResult: `${domain}/fencing/exportQueryResult`,
  fenceManageGetFileTemplate: `${domain}/fencing/getFileTemplate`,
  fenceManageUploadFile: `${domain}/fencing/uploadFile`,
  fenceManageCommitFile: `${domain}/fencing/commitFile`,
  fenceManageUpdate: `${domain}/fencing/update`,
  fenceManageSave: `${domain}/fencing/save`,
  fenceManageDetail: `${domain}/fencing/detail`,
  fenceManageChangeStatus: `${domain}/fencing/changeStatus`,
  fenceManageQueryBikeDetail: `${domain}/fencing/queryBikeDetail`,
  fenceManageCenterPoint: `${domain}/fencing/calc/centerPoint`,
  fenceManageQueryMapFences: `${domain}/fencing/point/list`,
  fenceManageQueryDepositionConfig: `${domain}/fencing/getDepositionConfig`,
  fenceManageCalculateCapacity: `${domain}/fencing/capacity/calculate`,
  fenceManageBatchChangeStatus: `${domain}/fencing/batchChangeStatus`,
  fenceManageBatchDelete: `${domain}/fencing/batchDelete`,
  fenceManageGetStatistics: `${domain}/violation-alarm/deposition-snapshot/getStatistics`,
  fenceManageDepositStatisticQueryPage: `${domain}/violation-alarm/deposition-history/query-page`,
  fenceManageExportExcel: `${domain}/violation-alarm/deposition-history/export-excel`,
  fenceManageDepositionTypeEnum: `${domain}/violation-alarm/deposition-history/query-deposition-type-enum`,
  fenceManageCreateOrde: `${domain}/violation-alarm/deposition-history/create-order`,
  fenceManageQueryBikeDetailById: `${domain}/violation-alarm/deposition-history/query-bike-details-by-id`,
  fenceManageSaveOrUpdatePoint: `${domain}/area-management/orderly/check/batchSaveOrUpdatePoint`,
  fenceManageQueryPointList: `${domain}/area-management/orderly/check/getPointList`,
  // ***************************** 围栏管理-秩序重点区域 *****************************
  orderKeyRegionList: `${domain}/area-management/orderly/page`,
  orderKeyRegionDelete: `${domain}/area-management/orderly/delete`,
  orderKeyRegionDetail: `${domain}/area-management/orderly/detail`,
  orderKeyRegionSave: `${domain}/area-management/orderly/save-or-update`,
  orderKeyRegionQueryMapFences: `${domain}/area-management/orderly/scope-all-list`,
  orderKeyRegionFenceRemoteSearch: `${domain}/area-management/orderly/search/suggest`,
  orderKeyRegionUploadFile: `${domain}/area-management/orderly/upload`,
  orderKeyRegionFileTemplate: `${domain}/area-management/orderly/file-template`,
  orderKeyRegionCommitFile: `${domain}/area-management/orderly/commit-file`,
  orderKeyRegionExportResult: `${domain}/area-management/orderly/export`,
  // ***************************** 秩序管理-重点区域表现 *****************************
  keyRegionPerformOrderlyResultOpts: `${domain}/orderly/overview/getConfig`,
  keyRegionPerformList: `${domain}/orderly/overview/getPageOverview`,
  keyRegionPerformDetail: `${domain}/orderly/overview/queryDetailWithStatistic`,
  // ***************************** 秩序管理-智能巡检明细 *****************************
  intelligentInspectionEntityConfigDisplayColumn: `${domain}/orderly/overview/getEntityConfigDisplayColumn`, // 查询实体配置的所有模型展示字段
  intelligentInspectionPageDetailList: `${domain}/orderly/overview/getPageDetailList`, // 巡视明细列表查询(分页)
  intelligentInspectionQueryDetailListToExcel: `${domain}/orderly/overview/queryDetailListToExcel`, // 巡视明细查询结果导出
  intelligentInspectionQueryUserNameList: `${domain}/user/queryUserNameList`, // 巡视人列表
  intelligentInspectionAuditConfig: `${domain}/orderly/overview/getAuditConfig`, // 人工审核开关查询接口
  intelligentInspectionHandleAudit: `${domain}/orderly/overview/detail/audit`, // 人工审核
  intelligentInspectionGetDetailInfo: `${domain}/orderly/overview/detail/getDetailInfo`, // 秩序巡检详情
  // ***************************** 考核配置 *****************************
  examineConfigQueryPage: `${domain}/evaluationCycle/queryPage`,
  examineConfigDelete: `${domain}/evaluationCycle/delete`,
  examineConfigQueryById: `${domain}/evaluationCycle/queryById`,
  examineConfigSaveOrUpdate: `${domain}/evaluationCycle/saveOrUpdate`,
  examineConfigItemQueryList: `${domain}/evaluationItem/queryList`,
  examineConfigItemQueryPage: `${domain}/evaluationItem/queryPage`,
  examineConfigItemAdd: `${domain}/evaluationItem/add`,
  examineConfigItemEdit: `${domain}/evaluationItem/edit`,
  examineConfigItemGetCalculateEnum: `${domain}/evaluationItem/getCalculateEnum`,
  examineConfigGetEvaluationCycleDurationEnumList: `${domain}/evaluationCycle/getEvaluationCycleDurationEnumList`,
  examineConfigCheckExistsResult: `${domain}/evaluationCycle/checkExistsResult`,
  examineConfigStatusChange: `${domain}/evaluationCycle/release`,
  examineConfigPublish: `${domain}/evaluationCycle/publish`,
  examineConfigPublishCheck: `${domain}/evaluationCycle/publishCheck`,
  examineConfigItemChangeStatus: `${domain}/evaluationItem/changeStatus`,
  // ***************************** 考核结果 *****************************
  evaluationResult: `${domain}/evaluationResult`,
  evaluationResultCorrection: `${domain}/evaluationResult/correction`,
  evaluationCycleQueryList: `${domain}/evaluationCycle/queryList`,
  getEvaluationRank: `${domain}/dashboard/query/getEvaluationRank`,
  // ***************************** 订单管理 *****************************
  orderDetailsList: `${domain}/orderDetails/queryPage`,
  orderDetailsExport: `${domain}/orderDetails/exportQueryResult`,
  orderDetailsQueryTotal: `${domain}/orderDetails/queryTotal`,
  // ***************************** 拍照识别溯源 *****************************
  photographQuerySelectList: `${domain}/orderly-regulation/bike-return-record/query-return-status-list`,
  photographQueryPage: `${domain}/orderly-regulation/bike-return-record/query-page`,
  photographExport: `${domain}/orderly-regulation/bike-return-record/export`,
  photographExportCount: `${domain}/orderly-regulation/bike-return-record/export/count`,
  // ***************************** 蓝牙嗅探 *****************************
  bluetoothSniffList: `${domain}/bikere-registration/bluetooth-sniff/getPageList`,
  bluetoothSniffGetDetail: `${domain}/bikere-registration/bluetooth-sniff/getDetail`,
  bluetoothSniffSettings: `${domain}/bikere-registration/bluetooth-sniff/settings`,
  bluetoothSniffSettingsUpdate: `${domain}/bikere-registration/bluetooth-sniff/settings-update`,
  bluetoothSniffExport: `${domain}/bikere-registration/bluetooth-sniff/export`,
  bluetoothSniffDetail: `${domain}/bikere-registration/bluetooth-sniff/queryDetailPage`,
  bluetoothSniffExportCount: `${domain}/bikere-registration/bluetooth-sniff/exportCount`,
  bluetoothSniffHistogramStatis: `${domain}/bikere-registration/bluetooth-sniff/histogramStatis`,
  // 蓝牙嗅探过滤配置
  bluetoothSniffFilterQuery: `${domain}/entity/bluetooth-sniff-filter/query`,
  bluetoothSniffFilterUpdate: `${domain}/entity/bluetooth-sniff-filter/update`,
  // ***************************** 运维信息 *****************************
  operateVehicleList: `${domain}/data-center/maintenance/vehicle/list`,
  operateVehicleExportExcel: `${domain}/data-center/maintenance/vehicle/export-excel`,
  operateVehiclePersonnelList: `${domain}/data-center/maintenance/personnel/list`,
  operateVehiclePersonnelExportExcel: `${domain}/data-center/maintenance/personnel/export-excel`,
  operateVehicleGetMaintenanceBikeTypeEnumMap: `${domain}/data-center/maintenance/getMaintenanceBikeTypeEnumMap`,
  operateVehicleStatisticsToday: `${domain}/dashboard/maintenance/today/statistics`,
  operateVehicleTrackList: `${domain}/data-center/maintenance/detail/track/list`,
  operateVehicleQueryPage: `${domain}/data-center/maintenance/detail/query-page`,
  operateOrderWorkQueryPage: `${domain}/maintenance/taskOrder/queryPage`,
  operateOrderWorkStatis: `${domain}/maintenance/taskOrder/statis`,
  // 摄像头管理
  nationalStandardVideoOnlineVideo: `${domain}/device/management/onlineVideo`, // 视频预览
  nationalStandardVideoQueryPageList: `${domain}/device/management/queryChannelPageList`, // 通道管理分页查询
  nationalStandardVideoQueryDelete: `${domain}/device/management/delete`, // 设备删除
  nationalStandardVideoQueryUpdate: `${domain}/device/management/updateChannel`, // 通道信息编辑
  nationalStandardVideoSaveCameraConf: `${domain}/device/saveAutoInspectionConf`, // 摄像头设置
  nationalStandardVideoQueryCameraConf: `${domain}/device/queryAutoInspectionConf`, // 摄像头设置查询接口
  nationalStandardServiceQueryInfo: `${domain}/device/service/queryBaseConfig`, // 当前平台信息查询
  nationalStandardServiceUpdateInfo: `${domain}/device/service/updateBaseConfig`, // 当前平台信息更新
  nationalStandardServiceFetchInfo: `${domain}/device/service/fetchInfo`, // 下级平台信息主动更新
  // API管理
  apiDiyList: `${domain}/apidiy/list`, // 映射列表查询
  apiDiyExport: `${domain}/apidiy/export`, // 映射列表导出
  apiDiyDetail: `${domain}/apidiy/detail`, // 数据详情查询
  apiDiyUpsert: `${domain}/apidiy/upsert`, // 数据更新
  apiDiyGetOriginInterfaceList: `${domain}/apidiy/getOriginInterfaceList`, // 原始接口信息获取
  apiDiyOnline: `${domain}/apidiy/online`, // 接口上线
  apiDiyOffline: `${domain}/apidiy/offline`, // 接口上线
  // 数据统计
  overviewBike: `${domain}/data-statistics/overview/bike`, // 车辆统计概览
  overviewOrder: `${domain}/data-statistics/overview/order`, // 订单统计概览
  overviewRunningBikeCount: `${domain}/data-statistics/line-chart/running-bike-count`, // 运营车辆折线图
  overviewActiveBikeCount: `${domain}/data-statistics/line-chart/active-bike-count`, // 活跃车折线图
  overviewOrderCount: `${domain}/data-statistics/line-chart/order-count`, // 订单数折线图
  overviewDistance: `${domain}/data-statistics/line-chart/distance`, // 骑行里程折线图
  overviewExport: `${domain}/data-statistics/export`, // 导出
  // 数据开放API配置
  openApiConfigApiList: `${domain}/apiConfig/queryAllApiList`,
  openApiConfigList: `${domain}/apiConfig/queryPage`,
  openApiConfigDetail: `${domain}/apiConfig/queryById`,
  openApiConfigSave: `${domain}/apiConfig/saveOrUpdate`,

  // 品牌管理
  brandManageQueryList: `${domain}/brand/queryPage`,
  brandManangeUpdate: `${domain}/brand/update`,
  brandManangeCreate: `${domain}/brand/save`,
  brandManageDelete: `${domain}/brand/del`,
  brandScanRulesQuery: `${domain}/brand/scan-rules/query`,
  // ***************************** 未备案数据过滤 *****************************
  // A-1 查询实体未备案数据过滤配置
  unregisteredFilterQuery: `${domain}/entity/unregistered-filter/query`,
  // A-2 保存/更新实体未备案数据过滤配置
  unregisteredFilterSave: `${domain}/entity/unregistered-filter/save`,
  // A-3 校验企业备案数据（传参 entityId + companyIds: number[]）
  unregisteredFilterValidateBrand: `${domain}/entity/unregistered-filter/validate-brand`,
  // A-4 未备案数据过滤记录分页查询
  unregisteredFilterRecordQueryPage: `${domain}/unregistered-filter/record/queryPage`,
  // A-5 未备案数据过滤记录触发异步导出
  unregisteredFilterRecordExport: `${domain}/unregistered-filter/record/exportQueryResult`,
  // A-6 未备案数据过滤记录查询导出总数
  unregisteredFilterRecordExportQueryCount: `${domain}/unregistered-filter/record/exportQueryCount`,
  // ***************************** 城市全量投放车辆维护入口 *****************************
  // A-1 分页查询
  cityVehiclePoolPageQuery: `${domain}/cityVehiclePool/pageQuery`,
  // A-2 单条新增
  cityVehiclePoolCreate: `${domain}/cityVehiclePool/create`,
  // A-3 单条编辑
  cityVehiclePoolUpdate: `${domain}/cityVehiclePool/update`,
  // A-4 单条删除
  cityVehiclePoolDelete: `${domain}/cityVehiclePool/delete`,
  // A-5 模板下载
  cityVehiclePoolTemplateDownload: `${domain}/cityVehiclePool/template/download`,
  // A-6 导入文件上传
  cityVehiclePoolImportUpload: `${domain}/cityVehiclePool/import/upload`,
  // A-7 导入提交
  cityVehiclePoolImportCommit: `${domain}/cityVehiclePool/import/commit`,
  // A-8 导出提交
  cityVehiclePoolExportSubmit: `${domain}/cityVehiclePool/export/submit`,
  // A-9 导入记录查询
  cityVehiclePoolImportRecords: `${domain}/cityVehiclePool/import/records`,
  // A-10 导出记录查询
  cityVehiclePoolExportRecords: `${domain}/cityVehiclePool/export/records`,
  // A-11 实体切换后的企业品牌列表
  cityVehiclePoolBrandListByUserType: `${domain}/company/getBrandListByUserType`,
  // 运营管理
  operationManageEntityList: `${domain}/operationManage/queryEntityList`,
  operationManageUpdateCityStatus: `${domain}/operation/entity/updateCityStatus`,
  operationManageUpdateEntityById: `${domain}/operationManage/updateEntityById`,
  operationManageCityAnalysisStatistics: `${domain}/operation/analysis/statistics`,
  operationManageStatisticsQueryTotalCount: `${domain}/operationManage/statistics/queryTotalCount`,
  // 城市分析统计图表
  operationManageArrivingEntityChart: `${domain}/operationManage/statistics/arrivingEntityChart`, // 落地城市统计
  operationManageBusinessDataChart: `${domain}/operationManage/statistics/businessDataChart`, // 行业数据统计
  operationManageBusinessTypeChart: `${domain}/operationManage/statistics/businessTypeChart`, // 业务线统计
  operationManageCityGradeChart: `${domain}/operationManage/statistics/cityGradeChart`, // 按城市等级统计
  operationManageHaveRivalChart: `${domain}/operationManage/statistics/haveRivalChart`, // 按有无竞对数据接入统计
  operationManageBusinessValueChart: `${domain}/operationManage/statistics/businessValueChart`, // 按业务价值统计
  operationManageFunctionChart: `${domain}/operationManage/statistics/functionChart`, // 按功能模块统计
}

module.exports = api
